import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../../core-ui/Directives/Directives.module';
import { TooltipModule } from '../../../core-ui/Tooltip/Tooltip.module';
import { ColorPalettePickerComponent } from './ColorPalettePicker.component';

@NgModule({
    imports: [CommonModule, TooltipModule, DirectivesModule, FormsModule],
    declarations: [ColorPalettePickerComponent],
    exports: [ColorPalettePickerComponent],
    providers: []
})
export class ColorPalettePickerModule {}
